// 依日期的預期工時
import * as types from '../actionType';

let initState = [];

function expectedWorkBydayState(state = initState, action) {
  switch (action.type) {
      case types.EXPECTED_WORKBYDAY_SHEET_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default expectedWorkBydayState;